export default "__VITE_ASSET__Ctl6XJ_i__"